export enum ESize {
  small = 'sm',
  large = 'lg',
}
